<template>
  <div class="shoppingCartList_box">
    <!--面包屑区域-->
    <div class="breadcrumb_box">
      <Breadcrumb>
        <BreadcrumbItem v-for="(item,index) in breadcrumbList" :to="item.path" :key="index">{{ item.title }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <!--购物车商品列表-->
    <div class="shoppingCartList_list">
      <div class="shoppingCartList_title_box">
        <Checkbox v-model="selectShoppingAll" :indeterminate="indeterminateAll" class="select_all_style"
          :disabled="shoppingCartData.length <=0" @on-change="updateAllSelectionState">{{ $t('key1000790') }}
        </Checkbox>
        <h2 class="width_340 text-align-center">{{ $t('key1000838') }}</h2>
        <h2 class="width_200 text-align-center">{{ $t('key1001342') }}</h2>
        <h2 class="width_150 text-align-center">{{ $t('key1000890') }}</h2>
        <h2 class="width_200 text-align-center">{{ $t('key1000523') }}</h2>
        <h2 class="width_140 text-align-center">{{ $t('key1001110') }}</h2>
        <h2 class="width_140 text-align-center">{{ $t('key1005945') }}</h2>
      </div>
      <template v-if="shoppingCartData.length>0">
        <div class="shoppingCartList_list_item" v-for="(item,index) in shoppingCartData" :key="index">
          <div class="flex align-items-center mb12">
            <Checkbox v-model="item.selectValue" :indeterminate="item.indeterminate"
              @on-change="(value) => handleSupplierSelect(value,item)" v-if="hasActiveGoods(item)"></Checkbox>
            <h2 class="font-weight-bold font-size-15 distributorThemeColor cursor" @click="toStoreList(item)">
              {{ item.supplierMerchantName }}
            </h2>
          </div>
          <div class="good_box" v-for="(ele,idx) in item.goodList">
            <div class="width_340 pr10 flex">
              <Checkbox v-if="ele.status !== 2" v-model="ele.selectGoodValue" @on-change="handleGoodSelect"></Checkbox>
              <!--商品-->
              <div class="flex">
                <div class="shoppingCart_img_box">
                  <img :src="ele.primaryImage" alt="">
                </div>
                <div class="ml12" style="flex: 1;">
                  <h2 class="font-size-14 color-333 font-weight-bold ellipsis_1" :title="ele.name">{{ ele.name }}</h2>
                  <p>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</p>
                  <p>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</p>
                  <div class="flex align-items-center">
                    <p class="distributorThemeColor">{{ ele.specifications }}</p>
                    <Icon size="18" color="#FD5425" class="cursor ml18" style="font-weight: bold;" type="ios-create-outline"
                      @click="$refs['changeSpecifications'].initChangeSpecificationsData(ele)"/>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="ele.status === 2">
              <p class="width_340" style="text-align: center; margin: 0 auto;">{{ $t('key1006654') }}
                <span class="distributorThemeColor cursor ml2 mr2" @click="deleteProductBtn('single', ele.ymsProductGoodsId)">{{ $t('key1000105') }}</span>
                {{ $t('key1006655') }}
              </p>
            </template>
            <template v-else>
              <!--发货仓-->
              <Select v-model="ele.ymsWarehouseId" transfer class="width_200" filterable
                @on-change="(value)=>selectChange(value, ele, idx, index)"
                @on-open-change="(value) => openChange(value, ele, idx, index)">
                <Option v-for="talg in ele.shippingWarehouseList" :disabled="talg.availableNumber<=0"
                  :value="talg.ymsWarehouseId" :key="talg.ymsWarehouseId" :label="talg.name">
                  <div class="flex align-items-center justify-content-between">
                    <span :class="talg.availableNumber<=0 ? '' : 'color-333'">{{ talg.name }}</span>
                    <span class="font-size-12 color-999">{{ '（' + $t('key1003367') + talg.availableNumber + '）' }}</span>
                  </div>
                </Option>
              </Select>
              <!--库存-->
              <p class="width_150 text-align-center">{{ ele.availableNumber }}</p>
              <!--数量-->
              <div class="flex align-items-center justify-content-center width_200">
                <InputNumber class="reset_input_style" v-model="ele.quantity" controls-outside
                  :formatter="value => `${parseInt(value)}`" :max="ele.availableNumber" :min="1"
                  @on-change="(value) => handleQuantityChange(value,ele)">
                </InputNumber>
                <Icon size="22" class="cursor ml12" type="ios-trash-outline" @click="deleteProductBtn('single', ele.ymsProductGoodsId)"/>
              </div>
              <!--单价-->
              <p class="width_140 text-align-center">{{ amountHandel(ele.unitPrice) + `（${currencyState}）` }}</p>
              <!--小计-->
              <p class="width_140 text-align-center">{{ amountHandel(ele.subtotal) + `（${currencyState}）` }}</p>
            </template>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="wid100P p20 font-size-15 color-333 back-fff mt20 mb20 text-align-center">{{ $t('key1006656') }}</div>
      </template>
      <!--操作-->
      <div class="options_box">
        <Button @click="deleteProductBtn('all')">{{ $t('key1000105') }}</Button>
        <div class="flex align-items-center">
          <div class="price_box">
            <span class="mr50">{{ $t('key1006653') + totalQuantityOfGoods + $t('key1005126') }}</span>
            <span>{{ $t('key1003883') }}</span>
            <span class="amount">{{ formatCurrency(totalAmount) }}</span>
            <span class="currency">{{ '(' + currencyState + ')' }}</span>
          </div>
          <Button type="primary" :disabled="!hasSelectedItems" @click="immediateSettlementBtn">{{ $t('key1006657') }}</Button>
        </div>
      </div>
    </div>
    <!--商品推荐列表-->
    <div class="recommend_box">
      <div class="recommend_box_item" v-for="(item, index) in commodityList" :key="index">
        <div class="recommend_title">
          <h2 class="title">{{ item.title }}</h2>
          <div class="flex align-items hoverStyles">
            <span class="text" @click="moreBtn(item)">{{ $t('key1000106') }}</span>
            <Icon size="16" class="forward_icon_styles" type="ios-arrow-forward"/>
          </div>
        </div>
        <div class="recommend_content">
          <div class="recommend_content_item" v-for="(ele,idx) in item.list" :key="idx">
            <div @click="gotoPath(`/shopDetails/${ele.ymsProductId}`)">
              <div class="img_box_styles">
                <image-box :src="getThumbnailImage(ele.primaryImage)" :animation="true"></image-box>
              </div>
              <p class="title" :title="ele.name">{{ ele.name }}</p>
              <template v-if="userInfo">
                <!--折扣价-->
                <template v-if="ele.freightDiscount !==1">
                  <p class="flex align-items-center justify-content-between">
                    <span class="price">{{ currencyState + currencySymbol(currencyState) + ele.minPrice }}</span>
                    <span class="original_price_style">{{ currencyState + currencySymbol(currencyState) + ele.minSuggestPrice }}</span>
                  </p>
                  <!--标签-->
                  <div class="activity_label_box" v-if="ele.activityGoodsLabelList">
                    <template v-for="talg in ele.activityGoodsLabelList">
                      <span class="activity_label_item" v-if="talg" style="background-color: #FF1810;">{{ talg }}</span>
                    </template>
                  </div>
                </template>
                <!--销售价-->
                <template v-else>
                  <p class="price">{{ currencyState + currencySymbol(currencyState) + ele.minSuggestPrice }}</p>
                </template>
              </template>
              <p class="price" v-else>{{ $t('key1006651') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--更换规格弹窗-->
    <changeSpecificationsModal ref="changeSpecifications" @updateData="getShoppingCartData()"></changeSpecificationsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import imageBox from "@/components/common/imageBox.vue";
import {
  amountHandel, pageJump, getHrefPath, commonLocalStorage, isJSON, getProductShippingWarehouseInventory,
  getTrialGoodsPrice, getSupplierData, getSetLanguages
} from "@/utils/common";
import changeSpecificationsModal from "@/views/shopping/index/components/changeSpecificationsModal.vue";

export default {
  name: 'shoppingCartList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      breadcrumbList: [
        {path: '/index', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006562'), talg: true},
        {path: '/shoppingCartList', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000224'), talg: true}
      ],
      commodityList: [],
      indeterminateAll: false,
      shoppingCartData: [],
      hasSelectedItems: false,
      debounceTimer: null,
      placeOfShipmentList: [],
    }
  },
  computed: {
    fromListing() {
      return this.$store.state.fromListing
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 全选
    selectShoppingAll: {
      get() {
        if (this.shoppingCartData.length === 0) return false;
        return this.shoppingCartData.every(supplier => supplier.goodList.every(good => good.selectGoodValue));
      },
      set(value) {
        this.shoppingCartData.forEach(supplier => {
          supplier.selectValue = value;
          supplier.goodList.forEach(good => {
            good.selectGoodValue = value;
            this.calculateItemTotal(good);
          });
        });
      }
    },
    // 商品数量总计
    totalQuantityOfGoods() {
      return this.shoppingCartData.reduce((total, supplier) => {
        return total + supplier.goodList.reduce((sum, good) => {
          return sum + (good.selectGoodValue && good.status !== 2 ? good.quantity : 0);
        }, 0);
      }, 0);
    },
    // 总金额
    totalAmount() {
      return amountHandel(this.shoppingCartData.reduce((total, supplier) => {
        return total + supplier.goodList.reduce((sum, good) => {
          return sum + (good.selectGoodValue && good.status !== 2 ? good.subtotal : 0);
        }, 0);
      }, 0));
    }
  },
  created() {
    this.getListData();
    this.getShoppingCartData();
  },
  methods: {
    amountHandel,
    // 获取购物车的数据
    getShoppingCartData() {
      this.shoppingCartData = [];
      this.axios.get(api.get_ymsProductCart_queryProductCartDetails, {loading: true}).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            let ymsProductGoodsIds = [];
            let supplierMerchantIdList = [];
            let list = [];
            data.map((item) => {
              if (item.ymsProductGoodsId) {
                ymsProductGoodsIds.push(item.ymsProductGoodsId)
              }
            });
            if (ymsProductGoodsIds.length > 0) {
              (async () => {
                let shippingWarehouseData = await getProductShippingWarehouseInventory(ymsProductGoodsIds);
                let newList = await this.getProductInfoByIds(ymsProductGoodsIds, data, false, false, false,
                  api.post_ymsDistributorProductInfo_queryByYmsProductGoodsIds);
                if (newList.length > 0) {
                  newList.map((item) => {
                    const _productInfo = item._productInfo;
                    if (_productInfo) {
                      let specificationsList = [];
                      let {
                        _spuInfo, ymsSku, productGoodsSpecificationList, weight, status,
                        availableNumber, ymsAvailableNumber
                      } = _productInfo;
                      let {supplierMerchantId, ymsProductId, name, primaryImage, ymsSpu} = _spuInfo;

                      if (productGoodsSpecificationList.length > 0) {
                        specificationsList = productGoodsSpecificationList.map((item) => {
                          return item.value
                        });
                      }
                      let specifications = specificationsList.join(' • ');
                      list.push({
                        ...item,
                        supplierMerchantId,
                        ymsProductId,
                        name,
                        primaryImage: _productInfo.primaryImage || primaryImage,
                        ymsSpu,
                        ymsSku,
                        weight,
                        status,
                        ymsAvailableNumber,
                        availableNumber,
                        selectValue: false,
                        indeterminate: false,
                        selectGoodValue: false,
                        supplierMerchantName: '',
                        specifications: specifications,
                        supplierSecondLevelDomain: '',
                        ymsWarehouseId: null,
                        shippingWarehouseList: [], // 发货仓
                      });
                      if (supplierMerchantId) {
                        supplierMerchantIdList.push(supplierMerchantId);
                      }
                    }
                  });
                  if (supplierMerchantIdList.length > 0) {
                    getSupplierData(supplierMerchantIdList).then(supplierList => {
                      let newData = supplierList || [];
                      list.map((item) => {
                        // 发货仓
                        shippingWarehouseData.map((talg) => {
                          if (item.ymsProductGoodsId === talg.ymsProductGoodsId) {
                            let list = talg.productDeliverWarehouseResultBos || [];
                            let newList = list.sort((a, b) => b.availableNumber - a.availableNumber);
                            newList.map((talg) => {
                              if (talg.ymsWarehouseId === item.ymsWarehouseId) {
                                item.availableNumber = talg.availableNumber;
                              }
                            });
                            item['shippingWarehouseList'] = newList;
                            if (!item.ymsWarehouseId) {
                              let ymsNewList = newList.filter((k) => k.servicePlatform === 'core' && k.availableNumber > 0);
                              let supplierNewList = newList.filter((k) => k.servicePlatform === 'supplier' && k.availableNumber > 0);
                              let list = ymsNewList.length > 0 ? ymsNewList : supplierNewList;
                              if (list.length > 0) {
                                item.availableNumber = list[0].availableNumber || 0;
                                item.ymsWarehouseId = list[0].availableNumber > 0 ? list[0].ymsWarehouseId : null;
                              }
                            }
                          }
                        });
                        // 供应商信息
                        newData.map((ele) => {
                          if (item.supplierMerchantId === ele.ymsMerchantId) {
                            let vals = ele.name;
                            item.supplierSecondLevelDomain = ele.supplierSecondLevelDomain;
                            if (vals) {
                              if (isJSON(vals)) {
                                let obj = JSON.parse(vals);
                                item.supplierMerchantName = obj[this.languagesVal] || '';
                              } else {
                                item.supplierMerchantName = vals;
                              }
                            }
                          }
                        });
                      });
                      // 获取单价、小计
                      this.getCommodityPrice(list).then((arr) => {
                        this.shoppingCartData = this.handerGrouping(arr, function (item) {
                          return [item.supplierMerchantId];
                        }, ['supplierMerchantId', 'supplierMerchantName', 'supplierSecondLevelDomain'], 'goodList');
                      })
                    });
                  }
                }
              })();
            }
          }
        }
      });
    },
    // 获取当前商品在指定仓库下的价格
    getCommodityPrice(productGoodsList, value) {
      const v = this;
      return new Promise((resolve) => {
        let queryList = [];
        productGoodsList.map((item) => {
          if (item.ymsWarehouseId) {
            let obj = {
              priceTrialGoodsBoList: [{
                quantity: item.quantity,
                ymsProductGoodsId: item.ymsProductGoodsId,
                isNeedCustomization: 0,
              }],
              ymsDistributorMerchantId: v.userInfo.merchantId,
              warehouseIds: [item.ymsWarehouseId]
            }
            queryList.push(obj);
          }
        });
        const handleData = (goodsList) => {
          if (value === 'update') {
            v.optionBtnWidth = [];
            v.tableData = goodsList;
            v.updateTableDom('tableDom');
            setTimeout(() => {
              v.updateTableDom('tableDom');
            }, 2000)
          }
          resolve(goodsList);
        }
        if (queryList.length > 0) {
          getTrialGoodsPrice({productGoodsList, queryList}).then((goodsList) => {
            handleData(goodsList)
          });
        } else {
          handleData(productGoodsList);
        }
      });
    },
    // 删除商品
    deleteProductBtn(type, ymsProductGoodsId) {
      let ymsProductGoodsIds = [];
      const hanledData = (ymsProductGoodsIds) => {
        this.axios.post(api.post_ymsProductCart_removeProductCart, ymsProductGoodsIds,
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
          if (response.data.code === 0) {
            this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002957'));
            this.getShoppingCartData();
          }
        });
      }
      // 批量
      if (type === 'all') {
        if (this.hasSelectedItems) {
          const selectedGoods = this.shoppingCartData.flatMap(supplier =>
            supplier.goodList.filter(good => good.selectGoodValue && good.status !== 2));
          ymsProductGoodsIds = selectedGoods.map((item) => {
            return item.ymsProductGoodsId
          });
          hanledData(ymsProductGoodsIds);
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006652'));
          return false;
        }
      }
      // 单个
      else {
        ymsProductGoodsIds = [ymsProductGoodsId];
        hanledData(ymsProductGoodsIds);
      }
    },
    // 立即结算
    immediateSettlementBtn() {
      const selectedGoods = this.shoppingCartData.flatMap(supplier =>
        supplier.goodList.filter(good => good.selectGoodValue && good.status !== 2)
      );
      if (selectedGoods.length > 0) {
        commonLocalStorage.setItem('shoppingCartData', selectedGoods);
        setTimeout(() => {
          pageJump('/index.html#/mallOrderSubmission?operationType=immediateSettlement', '/yms-shopping-service', '_self');
        }, 800);
      }
    },
    // 计算单个商品小计
    calculateItemTotal(good) {
      good.totalPrice = good.unitPrice * good.quantity;
    },
    // 更新供应商选择状态
    updateSupplierSelection() {
      this.shoppingCartData.forEach(supplier => {
        const activeGoods = supplier.goodList.filter(g => g.status !== 2);
        const selectedCount = activeGoods.filter(g => g.selectGoodValue).length;
        supplier.selectValue = selectedCount === activeGoods.length && activeGoods.length > 0;
        supplier.indeterminate = selectedCount > 0 && selectedCount < activeGoods.length;
      });
      this.$forceUpdate();
    },
    // 更新全选状态
    updateAllSelectionState() {
      const allGoods = this.shoppingCartData.flatMap(s => s.goodList.filter(g => g.status !== 2));
      const selectedCount = allGoods.filter(g => g.selectGoodValue).length;
      this.indeterminateAll = selectedCount > 0 && selectedCount < allGoods.length;
      this.updateButtonState();
      this.$forceUpdate();
    },
    // 供应商选择事件处理
    handleSupplierSelect(value, supplier) {
      supplier.selectValue = value;
      supplier.goodList.forEach(good => {
        if (good.status !== 2) {
          good.selectGoodValue = value;
          this.calculateItemTotal(good);
        }
      });
      this.updateAllSelectionState();
    },
    // 商品选择变化
    handleGoodSelect() {
      this.updateSupplierSelection();
      this.updateAllSelectionState();
    },
    // 数量变化处理
    handleQuantityChange(value, good) {
      let v = this;
      v.calculateItemTotal(good);
      v.$nextTick(() => {
        v.updateSupplierSelection();
        v.updateAllSelectionState();
      });
      if (v.debounceTimer) {
        clearTimeout(v.debounceTimer);
      }
      v.debounceTimer = setTimeout(() => {
        if (value > 0) {
          let query = {
            quantity: value,
            ymsProductGoodsId: good.ymsProductGoodsId
          };
          v.axios.post(api.post_ymsProductCart_updateProductCart, query).then((response) => {
            if (response.data.code === 0) {
              console.log('数量更新成功');
            }
          });
        }
        let list = [];
        v.shoppingCartData.forEach(good => {
          good.goodList.forEach(g => {
            list.push(g);
          })
        })
        v.getCommodityPrice(list).then((newData) => {
          v.shoppingCartData = v.handerGrouping(newData, function (item) {
            return [item.supplierMerchantId];
          }, ['supplierMerchantId', 'supplierMerchantName', 'supplierSecondLevelDomain'], 'goodList');
        });
      }, 1000);
    },
    // 判断是否有勾选商品
    updateButtonState() {
      this.hasSelectedItems = this.shoppingCartData.some(supplier =>
        supplier.goodList.some(good => good.selectGoodValue && good.status !== 2)
      );
    },
    // 进入店铺
    toStoreList(item) {
      let lang = getSetLanguages();
      let ymsDeliveryPlaceId = commonLocalStorage.getItem('ymsDeliveryPlaceId');
      if (this.fromListing) {
        window.location.href = item.supplierSecondLevelDomain + `?lang=${lang}&ymsDeliveryPlaceId=${ymsDeliveryPlaceId}`;
      } else {
        window.open(item.supplierSecondLevelDomain + `?lang=${lang}&ymsDeliveryPlaceId=${ymsDeliveryPlaceId}`, '_blank');
      }
    },
    // 获取商品推荐列表数据
    getListData() {
      let v = this;
      v.commodityList = [];
      let countryCode = v.showProductSaleCountrySet ? (commonLocalStorage.getItem('sellingCountry') || 'CN') : 'CN';
      let ymsDeliveryPlaceId = commonLocalStorage.getItem('ymsDeliveryPlaceId');
      let baseUrl = api.get_ymsProductInfo_shopping_queryForShowCase;
      let queryParams = [`ymsDeliveryPlaceId=${ymsDeliveryPlaceId}`];
      if (v.userInfo.merchantId) {
        queryParams.push(`distributorMerchantId=${v.userInfo.merchantId}`);
      }
      if (v.showProductSaleCountrySet) {
        queryParams.push(`countryCode=${countryCode}`);
      }
      let url = queryParams.length > 0 ? `${baseUrl}?${queryParams.join('&')}` : baseUrl;
      v.axios.get(url).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          let typeList = [
            {type: 5, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006650')}
          ];
          if (data.length > 0) {
            data.map((item) => {
              typeList.map((ele) => {
                if (item.type === ele.type) {
                  item.title = ele.title;
                  item.list = item.queryYmsProductInfoForShoppingResultBos || [];
                  if (item.list.length > 0) {
                    item.list.map((talg) => {
                      if (talg.freightDiscount !== 1) {
                        const priceFields = [
                          {value: talg.minFreightDiscountPrice, field: 'minFreightDiscountPrice'},
                          {value: talg.activityPrice, field: 'activityPrice'},
                          {value: talg.minSuggestPrice, field: 'minSuggestPrice'}
                        ].filter(price => price.value != null);
                        const minPrice = Math.min(...priceFields.map(price => price.value));
                        talg.minPrice = amountHandel(minPrice);
                        talg.activityGoodsLabelList = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000981')];
                      }
                      talg.minSuggestPrice = amountHandel(talg.minSuggestPrice);
                    })
                  }
                }
              })
            });
            v.commodityList = data.filter((item) => {
              if ([5].includes(item.type)) {
                return item;
              }
            });
          }
        }
      });
    },
    // 判断供应商是否有非停售商品
    hasActiveGoods(supplier) {
      return supplier.goodList.some(good => good.status !== 2);
    },
    // 点击更多按钮跳转到商品列表
    moreBtn(item) {
      if (item.ymsProductCategoryId) {
        if (this.fromListing) {
          window.location.href = getHrefPath(`/index.html#/shopList?ymsProductCategoryId=${item.ymsProductCategoryId}&commodityType=${item.type}`, '/yms-shopping-service');
        } else {
          pageJump(`/index.html#/shopList?ymsProductCategoryId=${item.ymsProductCategoryId}&commodityType=${item.type}`,
            '/yms-shopping-service', '_blank');
        }
      } else {
        if (this.fromListing) {
          window.location.href = getHrefPath(`/index.html#/shopList?activityTitle=${item.title}&commodityType=${item.type}`,
            '/yms-shopping-service',);
        } else {
          pageJump(`/index.html#/shopList?activityTitle=${item.title}&commodityType=${item.type}`,
            '/yms-shopping-service', '_blank');
        }

      }
    },
    // 是否展示售卖国
    showProductSaleCountrySet() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return Number(obj?.enableProductSaleCountrySet) === 1;
    },
    // 跳转到商城详情页
    gotoPath(path) {
      if (this.fromListing) {
        this.$router.push({
          path: path
        });
      } else {
        pageJump('/index.html#' + path, '/yms-shopping-service', '_blank')
      }
    },
    // 展开选择发货仓下拉框
    openChange(value, obj, idx, index) {
      let shippingWarehouseList = obj.shippingWarehouseList || [];
      if (value && shippingWarehouseList.length <= 0) {
        getProductShippingWarehouseInventory([obj.ymsProductGoodsId]).then((data) => {
          if (data.length > 0) {
            data.map((item) => {
              if (item.ymsProductGoodsId === obj.ymsProductGoodsId) {
                let list = item.productDeliverWarehouseResultBos || [];
                let newData = list.sort((a, b) => b.availableNumber - a.availableNumber);
                this.$set(this.shoppingCartData[index].goodList[idx], 'shippingWarehouseList', newData);
                this.$forceUpdate();
              }
            })
          }
        });
      }
    },
    // 选择发货仓
    selectChange(value, obj, idx, index) {
      let v = this;
      let shippingWarehouseList = obj.shippingWarehouseList || [];
      let availableNumber = shippingWarehouseList.filter((ele) => ele.ymsWarehouseId === value)[0].availableNumber;
      if (obj.quantity > availableNumber) {
        v.$set(this.shoppingCartData[index].goodList[idx], 'quantity', availableNumber);
      }
      v.$set(this.shoppingCartData[index].goodList[idx], 'availableNumber', availableNumber);
      let list = [];
      setTimeout(() => {
        v.shoppingCartData.forEach(good => {
          good.goodList.forEach(g => {
            list.push(g);
          })
        })
        v.getCommodityPrice(list).then((newData) => {
          v.shoppingCartData = v.handerGrouping(newData, function (item) {
            return [item.supplierMerchantId];
          }, ['supplierMerchantId', 'supplierMerchantName', 'supplierSecondLevelDomain'], 'goodList');
        });
      }, 1000);
    },
  },
  watch: {
    shoppingCartData: {
      deep: true,
      handler() {
        this.updateSupplierSelection();
        this.updateAllSelectionState();
      }
    }
  },
  components: {
    imageBox,
    changeSpecificationsModal
  },
  beforeDestroy() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
  }
};
</script>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.shoppingCartList_box {
  width: 1200px;
  margin: 0 auto;
  min-height: 400px;

  .breadcrumb_box {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;

    .breadcrumb_title {
      font-size: 14px;
      font-family: 'PingFangSC-Regular';
      color: #000;
      opacity: 0.5;
    }

    /deep/ .ivu-breadcrumb-item-separator {
      color: #515a6e;
      margin: 0 4px 0 0;
    }
  }

  .shoppingCartList_list {
    .shoppingCartList_title_box {
      padding: 12px 15px;
      width: 100%;
      display: flex;
      align-items: center;
      background-color: #F7F7F7;
      font-weight: bold;
      font-size: 15px;
      color: #333;
      position: relative;

      .select_all_style {
        position: absolute;
        left: 15px;
        top: 13px;
        font-size: 15px;
      }
    }

    .shoppingCartList_list_item {
      background-color: #fff;
      padding: 15px;
      margin-bottom: 20px;

      .good_box {
        display: flex;
        align-items: flex-start;
        border-bottom: 1px solid #E2E2E2;
        padding-bottom: 15px;
        margin-bottom: 18px;

        &:not(:last-child) {
          border-bottom: 1px solid #E2E2E2;
        }

        &:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }
      }

      .reset_input_style {
        /deep/ .ivu-input-number-controls-outside-btn i {
          font-size: 17px;
        }

        /deep/ .ivu-input-number-input {
          text-align: center;
        }
      }
    }

    .shoppingCart_img_box {
      width: 80px;
      height: 80px;
      position: relative;

      img {
        display: inline-block;
        left: 50%;
        max-height: 100%;
        max-width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%) translateX(-50%);
      }
    }
  }

  .recommend_box {
    width: 100%;
    margin-top: 24px;

    .recommend_box_item {
      margin-bottom: 24px;

      .recommend_title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;

        .title {
          font-family: 'PingFangSC-Semibold';
          font-weight: bold;
          font-size: 18px;
          color: #000;
        }

        .text {
          cursor: pointer;
          color: #666;
          font-size: 14px;
          font-family: 'PingFangSC-Regular';
        }

        .hoverStyles:hover {
          .text {
            color: @subject_color;
            text-decoration: underline;
          }

          .forward_icon_styles {
            color: @subject_color;
          }
        }
      }

      .recommend_content {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .recommend_content_item {
          width: 228px;
          height: 298px;
          background-color: #fff;
          cursor: pointer;
          margin: 0 15px 15px 0;
          position: relative;

          .img_box_styles {
            width: 228px;
            height: 228px;
            overflow: hidden;
            display: inline-block;
          }

          .title {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #000;
            font-size: 14px;
            font-family: 'PingFangSC-Regular';
            padding: 0 8px;
            margin: 6px 0 8px 0;
          }

          .price {
            font-family: 'PingFangSC-Semibold';
            padding: 0 8px;
            font-size: 14px;
            font-weight: 600;
            color: #000;
          }

          .original_price_style {
            color: #8D8D8D;
            text-decoration: line-through;
            padding-left: 5px;
            font-weight: normal;
            padding-right: 8px;
          }

          &:hover {
            box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1500);
          }
        }

        .recommend_content_item:nth-child(5n+5) {
          margin-right: 0;
        }
      }
    }
  }

  .activity_label_box {
    position: absolute;
    top: 0px;
    left: 0;
    display: flex;
    flex-direction: column;
    z-index: 100;

    .activity_label_item {
      color: #fff;
      font-size: 12px;
      border-bottom-right-radius: 15px;
      padding: 2px 8px;
      display: inline-block;
      margin-bottom: 8px;
    }
  }

  .options_box {
    height: 55px;
    width: 100%;
    background-color: #fff;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .price_box {
      margin-right: 40px;

      .amount {
        color: #FF4400;
        font-size: 25px;
        font-weight: bold;
      }

      .currency {
        color: #FD5425;
        font-size: 14px;
        margin-left: 6px;
        vertical-align: text-bottom;
      }
    }
  }
}
</style>
